export default "__VITE_PUBLIC_ASSET__a3697840__"